import React from 'react';
import { HomeHeroSection } from 'organisms';

type HomeTemplateProps = {
  heroLogo: string;
  aquaristLogo: string;
  idleCafeLogo: string;
};

const HomeTemplate: React.FC<HomeTemplateProps> = ({
  heroLogo,
  aquaristLogo,
  idleCafeLogo,
}) => {
  return (
    <>
      <HomeHeroSection
        heroLogoSrc={heroLogo}
        aquaristLogoSrc={aquaristLogo}
        idleCafeLogoSrc={idleCafeLogo}
      />
    </>
  );
};

export default HomeTemplate;
